// store/thunks/auth/verify2faCodeThunk.ts

import { MIN_LEN } from "@/constants";
import { createAdminAsyncThunk } from "@/store/thunks/createAdminAsyncThunk";
import type { FinalizeVerifyDTO } from "@/types/dtos.types";
import { setSessionToken } from "@/utils/sessionStorage";

import { withLoader } from "../thunkWrappers";

export const verify2faCodeThunk = createAdminAsyncThunk<
  FinalizeVerifyDTO,
  { code: string },
  { rejectValue: { message: string } }
>('auth/verify2faCode',withLoader( async({ code }, { getState, extra: { authService }, rejectWithValue }) => {
  const state = getState();
  const twoFactorToken = state.auth.regToken;

  if (twoFactorToken === undefined || twoFactorToken.trim().length === MIN_LEN) {
    return rejectWithValue({ message: 'Missing two-factor token' });
  }

  try {
    const result = await authService.verifyTwoFactorCode({
      code,
      twoFactorToken,
    });
    setSessionToken(result.sessionToken);
    return result;
  } catch (caught) {
    const message = caught instanceof Error ? caught.message : 'Failed to verify 2FA code';
    return rejectWithValue({ message });
  }
}));

